'use client'
import {
  context_default
} from "./chunk-5YUCCO3N.mjs";

// src/context/root/useCurrency.ts
import { useContext } from "react";
var useCurrency = () => {
  const context = useContext(context_default);
  return context;
};
var useCurrency_default = useCurrency;

export {
  useCurrency,
  useCurrency_default
};
//# sourceMappingURL=chunk-ORN7IGBC.mjs.map